/**
 * /market — the marketplace layout route (SPEC-13 / SPEC-16).
 *
 * FLAG GATE (byte-identical OFF): the shared area is behind the canonical
 * Talent and Store build masters. Child runtime stages come only from the
 * authenticated gateway capability DTO.
 * On an OFF build the rail never renders a Market icon and this beforeLoad
 * redirects any direct hit to Home, so the area is fully inert when disabled.
 *
 * THE UI FLAG AND THE GATEWAY FLAG ARE TWO SWITCHES, NOT ONE. VITE_MARKETPLACE
 * is BAKED into the bundle at build time — flipping it needs an image rebuild,
 * a container recreate does nothing. MARKETPLACE_ENABLED is read by the
 * gateway process and flips on a recreate. A UI-on / gateway-off build is a
 * real and expected state, and it renders <DisabledPanel/> rather than an
 * error boundary: a switched-off feature that looks like a crash gets a bug
 * filed against a switch.
 *
 * SIGNED-IN ONLY, AND NOW FOR A DIFFERENT REASON THAN THIS COMMENT USED TO GIVE.
 * It said the public page was an open founder decision. It was answered on
 * 2026-07-30 (FOUNDER_DECISIONS_REGISTER.md:142/:500) — the public pack and expert
 * pages render SERVER-SIDE for search indexing while this app stays the SPA — and
 * the comment stayed stale for six weeks afterwards, which is how a reader stops
 * trusting the rest of the file.
 *
 * The public pages are the gateway's
 * (apps/chaos-gateway/src/lib/marketplace-public-storefront.ts), they carry a
 * `default-src 'none'` CSP with no script at all, and nothing in this app renders
 * or links into them. So these routes are signed-in because they are the
 * AUTHENTICATED half of a product that has two — not because the other half is
 * undecided.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { env } from '../../env';

export const Route = createFileRoute('/_authenticated/market')({
  beforeLoad: () => {
    if (!(env.VITE_MARKETPLACE || env.VITE_SKILLS_STORE)) {
      throw redirect({ to: '/' });
    }
  },
});
